import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types/image';

export interface IconAndDescriptionProps {
  icon?: ImageProps;
  description: string;
  label?: string;
}
export const GriddleIconDescription = ({ icon, description, label }: IconAndDescriptionProps) => {
  if (!description) return null;
  return (
    <div className="gap-2 flex flex-col sm:gap-6 sm:grid sm:grid-cols-[1fr_2fr] max-w-smallBody m-auto">
      <div className="bg-neutral-600 flex flex-col justify-center p-4 md:p-8 items-center">
        {icon && (
          /* eslint-disable-next-line @next/next/no-img-element */
          <img src={buildImageSrc(icon, 600, 0, 0)} alt={icon.altTag} />
        )}
        {label && <p className="text-neutral-100 pt-4 sm:pt-6 tra-text-web-heading-h4">{label}</p>}
      </div>
      <div className="bg-neutral-600 flex flex-col justify-center p-4 md:p-8">
        <p className="text-neutral-100 mb-0 tra-text-web-body-xl">{description}</p>
      </div>
    </div>
  );
};

export default GriddleIconDescription;
